import { useFormContext } from "react-hook-form";
import {
  FormController,
  MuiBox,
  MuiGrid,
  MuiSelect,
  MuiTextField,
  MuiTypography,
  OptionsDataType,
} from "../../../../../../../../components";
import {
  gridSize,
  MAX_LENGTH_15,
  MAX_LENGTH_75,
} from "../../../../../../../../helpers/constants";
import { validateAndFormatNumericInput } from "../../../../../../../../helpers/utils";
import { useNavigationSiteCore } from "../../../../../../../../hooks/useNavigationSiteCore";
import { useSiteCore } from "../../../../../../../../hooks/useSiteCore";
import { AddOrEditExpenseOrFeeFormKey } from "../../../../../../modelsAndSchemas/Models";
import { addFeesAndExpensesSiteCoreKeys } from "../../../../../../siteCore/SiteCoreKeys";

interface GeneralFromExpenseDetailsFieldsProps {
  categoryOptions: OptionsDataType[];
  typeOptions: OptionsDataType[];
  children: string | React.JSX.Element | React.JSX.Element[];
}

export const GeneralFromExpenseDetailsFields = ({
  children: currencyAndAmountFields,
  categoryOptions,
  typeOptions,
}: GeneralFromExpenseDetailsFieldsProps) => {
  const { useFetchLabel, commonLabels } = useSiteCore();
  const { commonARIALabel } = useNavigationSiteCore();
  const { control, setValue } = useFormContext();

  const getLabel = useFetchLabel(
    addFeesAndExpensesSiteCoreKeys.addFeesAndExpenses,
  );

  const handleOnChangeUnitPrice = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;

    setValue(
      AddOrEditExpenseOrFeeFormKey.expenseUnitPrice,
      validateAndFormatNumericInput(value, MAX_LENGTH_15),
    );
  };

  return (
    <MuiBox className="form-section">
      <MuiBox className="form-section-header">
        <MuiTypography variant="h2SemiBold">
          {getLabel(addFeesAndExpensesSiteCoreKeys.expenseDetailsHeading)}
        </MuiTypography>
      </MuiBox>
      <MuiGrid container spacing={2}>
        <MuiGrid size={gridSize}>
          <FormController
            control={control}
            name={AddOrEditExpenseOrFeeFormKey.expenseCategoryId}
          >
            <MuiSelect
              label={getLabel(
                addFeesAndExpensesSiteCoreKeys.expenseDetailsCategory,
              )}
              options={categoryOptions}
              visibleDefaultSelectOption
              placeholder={commonLabels.selectPlaceHolder}
              isMandatory
              requiredARIALabel={commonARIALabel.required}
            />
          </FormController>
        </MuiGrid>
        <MuiGrid size={gridSize} spacing={2}>
          <FormController
            control={control}
            name={AddOrEditExpenseOrFeeFormKey.expenseTypeId}
          >
            <MuiSelect
              label={getLabel(
                addFeesAndExpensesSiteCoreKeys.expenseDetailsType,
              )}
              options={typeOptions}
              visibleDefaultSelectOption
              placeholder={commonLabels.selectPlaceHolder}
              isMandatory
              requiredARIALabel={commonARIALabel.required}
            />
          </FormController>
        </MuiGrid>

        <MuiGrid size={gridSize} spacing={2}>
          <FormController
            control={control}
            name={AddOrEditExpenseOrFeeFormKey.expenseUnitPrice}
          >
            <MuiTextField
              id={AddOrEditExpenseOrFeeFormKey.expenseUnitPrice}
              isMandatory
              label={getLabel(
                addFeesAndExpensesSiteCoreKeys.expenseDetailsUnitPrice,
              )}
              placeholder={commonLabels.inputPlaceHolder}
              maxLength={MAX_LENGTH_15}
              showCloseIcon
              type="number"
              positiveValuesOnly
              onChange={handleOnChangeUnitPrice}
              requiredARIALabel={commonARIALabel.required}
            />
          </FormController>
        </MuiGrid>
        <MuiGrid size={gridSize} spacing={2}>
          <FormController
            control={control}
            name={AddOrEditExpenseOrFeeFormKey.expenseQuantity}
          >
            <MuiTextField
              label={getLabel(
                addFeesAndExpensesSiteCoreKeys.expenseDetailsQuantity,
              )}
              placeholder={commonLabels.inputPlaceHolder}
              maxLength={MAX_LENGTH_75}
              showCloseIcon
              isMandatory
              type="number"
              requiredARIALabel={commonARIALabel.required}
              inputNumberWithoutDecimal
              positiveValuesOnly
            />
          </FormController>
        </MuiGrid>
        {currencyAndAmountFields}
      </MuiGrid>
    </MuiBox>
  );
};
